const LEAD_MEMBERS = [
{
    name: 'Douglas DS Kim, Ph.D.',
    role: 'CEO & Founder',
    info: ' Leading researcher of Voronoi diagrams for theory, algorithms and applications. He has introduced Voronoi diagram for saferand more efficient space.',
    img: '/team/Douglas_Kim.jpg',
  },
  {
    name: 'Peter JH Ryu, Ph.D.',
    role: 'CTO',
    info: 'Leading mathematician for computational geometry, splines, optimization, statistics, etc. He always implements the core library.',
    img: '/team/Peter_Ryu.jpg',
  },
  {
    name: 'Jaime JH Yoo',
    role: 'CFO',
    info: 'Certified Public Accountant & the principal partner of Sejung Accounting Firm.',
    img: '/team/Jaime.Yoo.jpg',
  },
  {
    name: 'Shawn SH Choi, Ph.D.',
    role: 'CPO',
    info: 'Leading manager for product development. Ph.D. candidate. He has the leadership for the product concept and architectures.',
    img: '/team/Shawn_Choi.jpg',
  },
  {
    name: 'Martin YH Yoon',
    role: 'COO',
    info: 'Leading manager for Management Support. Bachelor of Business Administration and Law.',
    img: '/team/Martin_Yoon.jpg',
  },
]

const DEVELOPER = [
{
    name: 'Henry HO Hur',
    role: 'Software Development',
    info: 'Ph. D. in Astronomy.',
    img: '/team/Henry_Hur.jpg',
  },
  {
    name: 'Franklin DI Kang',
    role: 'Software Development',
    info: 'Powerful front-end developer.',
    img: '/team/Franklin_Kang.jpg',
  },
  {
    name: 'Samuel YM Lee',
    role: 'Software Development',
    info: 'Powerful front-end developer.',
    img: '/team/Samuel_Lee.jpg',
  },
  {
    name: 'Ethan SH Roh',
    role: 'Software Development',
    info: 'Powerful front-end developer.',
    img: '/team/Ethan_Roh.jpg',
  },
  {
    name: 'Chase SG Hong',
    role: 'Software Development',
    info: 'Powerful front-end developer.',
    img: '/team/Chase_Hong.jpg',
  },
  {
    name: 'Daniel MO Cho',
    role: 'Software Development',
    info: 'Powerful front-end developer.',
    img: '/team/Daniel_Cho.jpg',
  },
  {
    name: 'Zion JH Nam',
    role: 'Software Development',
    info: '',
    img: '/team/Zion_Nam.jpg',
  },
]

const BUSINESS = [
{
    name: 'Jayden MS Jeon',
    role: 'Senior Associate',
    info: '',
    img: '/team/Jayden_Jeon.jpg',
  },
  {
    name: 'Ellen CE Wi',
    role: 'Associate',
    info: '',
    img: '/team/Ellen_Wi.jpg',
  },
  {
    name: 'Bella DH Oh',
    role: 'Designer',
    info: '',
    img: '/team/Bella_Oh.jpg',
  },
  {
    name: 'Jay JH Lee',
    role: 'Business Lead',
    info: '',
    img: '/team/Jay_Lee.jpg',
  },
  {
    name: 'Ian YJ Cho',
    role: 'Business Manager',
    info: '',
    img: '/team/Ian_Cho.jpg',
  },
]

const ADVISORS = [
  {
    name: 'Hee Yol Yu',
    role: 'Senior Advisor',
    info: 'Former Board Chairman of Korea Telecommunication (KT), Former Vice Minister of Ministry of Science and Technology, Korea. He has paved the cornerstones of Korean science and technology and contributed to the rapid growth of KT.',
    img: '/team/Hee-Yol-Yu.jpg',
  },
  {
    name: 'Misoon Y. Mah, Ph.D.',
    role: 'Senior Advisor',
    info: 'President and CEO of M&K Research and Development Inc, Former AFRL Program Officer. She served at AFRL over 38 years.',
    img: '/team/Misoon-Y.-Mah,-Ph.D.jpg',
  },
  {
    name: 'Dae Young Lee, Ph.D.',
    role: 'Advisor, Orbit Mechanics',
    info: 'Assistant Professor, Department of Aerospace Engineering, Iowa State University. He is one of leading experts in satellite attitude control.',
    img: '/team/Dae-Young-Lee,-Ph.D.jpg',
  },
  {
    name: 'Alina Shymanska, Ph.D.',
    role: 'Global Strategy',
    info: '',
    img: '/team/alina.shymanska.jpg',
  },
];

export { LEAD_MEMBERS, BUSINESS, DEVELOPER, ADVISORS };
